import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Container, Col, Row } from "react-bootstrap";
import BotonSalir from "../../components/estudiantes/BotonSalir";
import PreguntasFrecuentes from "../../components/estudiantes/PreguntasFrecuentes";
import Ticket from "../../components/estudiantes/Ticket";
import ModalConfirmar from "../../components/estudiantes/ModalConfirmar";

import { getTicketInfo, leaveQueue } from "../../services/apis_estudiante";

const styles = {
    body: {
        fontFamily: "var(--font-estudiantes)",
        backgroundColor: "var(--color-primary)",
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        alignItems: "center"
    }
};

function Fila() {

    const location = useLocation();
    const navigate = useNavigate();

    // Ticket inicial que llega desde la redirección
    const storedTicket = sessionStorage.getItem("ticketActivo");
    const initialData = location.state || (storedTicket ? JSON.parse(storedTicket) : null);
    const [ticketData, setTicketData] = useState(initialData);

    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
      if (!ticketData?.id) {
        navigate("/inicio");
        return;
      }

      let interval;

      async function fetchData() {
        try {
          const data = await getTicketInfo(ticketData.id);
          setTicketData((prev) => ({ ...prev, ...data }));

          if (data.estado === "atendido") {
            navigate(`/turno`, { state: { ...ticketData, ...data } });
          }
        } catch (err) {
          console.error("Error en fetchData:", err);
        }
      }

      fetchData();
      interval = setInterval(fetchData, 2000);

      return () => clearInterval(interval);
    }, [ticketData?.id, navigate]);


    if (!ticketData) return <p className="text-center mt-5">Cargando...</p>;

    const handleOpenModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);

    const handleSalir = async () => {
        try {
            await leaveQueue(ticketData.id);
            sessionStorage.removeItem("ticketActivo");
            setShowModal(false);
            navigate("/inicio"); // redirigir al inicio tras salir
        } catch (err) {
            console.error("Error al salir de la fila:", err);
        }
    };

    return (
        <div style = {styles.body}>
            <Container fluid className="p-0 m-0" >
                <Row className="g-0 my-0 py-0" >
                    <Col md={12} lg={6} className="px-4 px-lg-4 mt-5 my-lg-auto">
                        <Ticket numero={initialData.numero_ticket} personasAntes={ticketData.posicion} />
                        <BotonSalir onClick={handleOpenModal}/>
                    </Col>
                    <Col md={12} lg={6} className="my-auto pt-5 pt-lg-0">
                        <PreguntasFrecuentes />
                    </Col>
                    <ModalConfirmar
                        isOpen={showModal}
                        onClose={handleCloseModal}
                        onConfirm={handleSalir}
                    />
                </Row>
            </Container>
        </div>
    );
}
export default Fila;
